<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Cotação</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar" v-if="getPermission('cotacao.store')"><i class="fa fa-plus"></i></a></li>
                                    <li><a @click="onFilterReset()" v-b-tooltip title="Atualizar listagem"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros"  v-if="getPermission('cotacao.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(3, null, false)" v-b-tooltip title="Inutilizar Registros"  v-if="getPermission('cotacao.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    <div class="card-content">
                        <div class="table-responsive">
                            <div v-if="vuetableFilterRow">
                                <vuetable-filterbar>
                                </vuetable-filterbar>
                            </div>
                        <div class="loadingDataPosition">
                            <div class="loadingData" v-if="loadingData"><div class="loadingDataSpinner"><spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                            <vuetable ref="vuetable"
                                    api-url="/api/cotacao"
                                    :fields="fields"
                                    :css="css"
                                    :append-params="moreParams"
                                    track-by="cotacao_id"
                                    pagination-path=""
                                    @vuetable:load-error="onError"
                                    detail-row-component="cotacao-detalhes"
                                    @vuetable:cell-clicked="onDetail"
                                    @vuetable:pagination-data="onPaginationData"
                                    @vuetable:loaded="onLoaded"
                                  >
                                  <template slot="status" slot-scope="props">
                                      <span class="badge badge-warning" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                      <span class="badge badge-success" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                      <span class="badge badge-danger" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}</span>
                                  </template>
                                  <template slot="tomador" slot-scope="props">
                                      <span class="badge badge-warning" v-if="props.rowData.tomador.valor==0">{{ props.rowData.tomador.descr }}</span>
                                      <span class="badge badge-info" v-if="props.rowData.tomador.valor==1">{{ props.rowData.tomador.descr }}</span>
                                      <span class="badge badge-secondary" v-if="props.rowData.tomador.valor==2">{{ props.rowData.tomador.descr }}</span>
                                      <span class="badge badge-success" v-if="props.rowData.tomador.valor==3">{{ props.rowData.tomador.descr }}</span>
                                      <span class="badge badge-danger" v-if="props.rowData.tomador.valor==4">{{ props.rowData.tomador.descr }}</span>
                                  </template>
                                  <template slot="tp_carga" slot-scope="props">
                                      <span class="badge badge-success" v-if="props.rowData.tp_carga.valor==0">{{ props.rowData.tp_carga.descr }}</span>
                                      <span class="badge badge-info" v-if="props.rowData.tp_carga.valor==1">{{ props.rowData.tp_carga.descr }}</span>
                                      <span class="badge badge-secondary" v-if="props.rowData.tp_carga.valor==2">{{ props.rowData.tp_carga.descr }}</span>
                                      <span class="badge badge-warning" v-if="props.rowData.tp_carga.valor==3">{{ props.rowData.tp_carga.descr }}</span>
                                      <span class="badge badge-danger" v-if="props.rowData.tp_carga.valor==4">{{ props.rowData.tp_carga.descr }}</span>
                                  </template>
                                  <template slot="pessoa_origem" slot-scope="props">
                                      <span v-if="props.rowData.pessoa_origem!==null && props.rowData.pessoa_origem.pessoa_fisica!==null">{{props.rowData.pessoa_origem.pessoa_fisica.nome}} - {{props.rowData.pessoa_origem.pessoa_fisica.cpf}}</span>
                                      <span v-if="props.rowData.pessoa_origem!==null && props.rowData.pessoa_origem.pessoa_juridica!==null">{{props.rowData.pessoa_origem.pessoa_juridica.razao_social}} CNPJ: {{onFormataCnpj(props.rowData.pessoa_origem.pessoa_juridica.cnpj_base,props.rowData.pessoa_origem.pessoa_juridica.cnpj_filial,props.rowData.pessoa_origem.pessoa_juridica.cnpj_digito)}} IE: {{props.rowData.pessoa_origem.pessoa_juridica.inscricao_estadual}}</span>
                                      <span v-if="props.rowData.pessoa_origem!==null && props.rowData.pessoa_origem.pessoa_exterior!==null">{{props.rowData.pessoa_origem.pessoa_exterior.nome}} - {{props.rowData.pessoa_origem.pessoa_exterior.cd}}</span>
                                  </template>
                                  <template slot="actions" slot-scope="props">
                                    <div class="custom-actions">
                                        <a @click="onEdit(props.rowData, props.rowIndex)" v-b-tooltip title="Editar"  v-if="getPermission('cotacao.update')"><i class="fa fa-edit"></i></a>
                                        <a @click="onGeraPedido(props.rowData)" v-b-tooltip title="Gerar Pedido"  v-if="getPermission('cotacao.update')"><i class="fa fa-file"></i></a>
                                        <a @click="onEditPedido(props.rowData)" v-b-tooltip title="Gerar Pedido ajustado"  v-if="getPermission('cotacao.update')"><i class="fa fa-file"></i></a>
                                        <a v-if="props.rowData.status.valor==1 && getPermission('tabelafrete.update')" @click="onAprova(props.rowData)" v-b-tooltip title="Aprovar"><i class="fa fa-check"></i></a>
                                        <a v-if="props.rowData.status.valor!=3 && getPermission('tabelafrete.update')" @click="onCancela(props.rowData)" v-b-tooltip title="Cancelar"><i class="fa fa-times"></i></a>
                                        <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                    </div>
                                  </template>
                            </vuetable>
                        </div>
                    <div>
                        <div class='col-md-12'>
                            <div class="pull-left pagination-detail">
                                <vuetable-pagination-info ref="paginationInfo"
                                                          :css="css.pagination"
                                                          info-class="pull-left"
                                ></vuetable-pagination-info>
                            </div>
                            <div class="pull-right m-a-0">
                                <vuetable-pagination ref="pagination"
                                                     :css="css.pagination"
                                                     @vuetable-pagination:change-page="onChangePage"
                                ></vuetable-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
                <!-- Modal Component -->
                <b-modal id="modal_form"
                         ref="modal_form"
                         :title="modal_titulo"
                         :ok-title="modal_botao"
                         close-title="Fechar"
                         cancel-title="Cancelar"
                         size="lg"
                         no-close-on-esc
                         no-close-on-backdrop
                         :ok-disabled=form.errors.any()
                         v-model="showModal"
                         @ok="handleOk">

               <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                   <b-container fluid>
                       <div class="row">
                           <div class="col-md-8">
                               <b-row>
                                   <b-col md="12" sm="12" class="p-0">
                                       <label>Descrição</label>
                                       <b-form-input type="text"
                                                     placeholder="Descrição"
                                                     v-model="form.descr"
                                                     name="descr"
                                                     >
                                       </b-form-input>
                                       <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
                                   </b-col>
                               </b-row>
                               <b-row>
                                   <b-col md="6" sm="6" class="p-0">
                                      <label>Cliente Origem</label>
                                      <multiselect v-model="form.pessoa_origem"
                                      :options-limit="300"
                                      :limit="2"
                                      :limit-text="limitText"
                                      :options="optionsPessoa"
                                      track-by="value"
                                      label="label"
                                      id="cliente_ori"
                                      :hide-selected="true"
                                      placeholder="Cliente ( Digite 3 caracteres para pesquisar )"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      :searchable="true"
                                      :loading="isLoadingPessoa"
                                      @search-change="listaClientesPessoa"
                                      @input="getEndereco(form, 1)"
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('pessoa_origem.value')" v-if="form.errors.has('pessoa_origem.value')"></b-form-feedback>
                                   </b-col>
                                   <b-col md="6" sm="6" class="p-0">
                                      <label>Cliente Destino</label>
                                      <multiselect v-model="form.pessoa_destino"
                                      :options-limit="300"
                                      :limit="2"
                                      :limit-text="limitText"
                                      :options="optionsPessoa"
                                      track-by="value"
                                      label="label"
                                      id="cliente_des"
                                      :hide-selected="true"
                                      placeholder="Cliente ( Digite 3 caracteres para pesquisar )"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      :searchable="true"
                                      :loading="isLoadingPessoa"
                                      @search-change="listaClientesPessoa"
                                      @input="getEndereco(form, 2)"
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('pessoa_destino.value')" v-if="form.errors.has('pessoa_destino.value')"></b-form-feedback>
                                   </b-col>
                               </b-row>
                           </div>
                           <div class="col-md-4">
                               <b-row>
                                   <b-col md="5" sm="5">
                                       <label>Tipo carga</label>
                                       <b-form-group class="p-0">
                                         <b-form-radio-group
                                           v-model="form.tp_carga"
                                           :options="optionsCotacaoTpCarga"
                                           name="tp_carga"
                                           plain
                                           stacked
                                           value-field="value"
                                         ></b-form-radio-group>
                                       </b-form-group>
                                       <b-form-feedback v-text="form.errors.get('tp_carga')" v-if="form.errors.has('tp_carga')"></b-form-feedback>
                                   </b-col>
                                   <b-col class="p-0" md="5" sm="5">
                                       <label>Tomador</label>
                                       <b-form-group class="p-0">
                                         <b-form-radio-group
                                           v-model="form.tomador"
                                           :options="optionsCotacaoTomador"
                                           name="tomador"
                                           plain
                                           stacked
                                         ></b-form-radio-group>
                                       </b-form-group>
                                       <b-form-feedback v-text="form.errors.get('tomador')" v-if="form.errors.has('tomador')"></b-form-feedback>
                                   </b-col>
                                   <b-col md="2" sm="2" class="pt-2 p-0">
                                       <i id="popover-1" class="fa fa-commenting-o fa-2x" v-b-tooltip.hover.bottom="'Adicionar Observação'" tabindex="0" style="cursor: pointer"></i>
                                       <b-popover placement="bottom" target="popover-1" variant="danger" triggers="focus">
                                         <label class="panel-title">Observação</label>
                                         <b-form-textarea id="textarea1"
                                                          name="obs"
                                                          v-model="form.obs"
                                                          placeholder="Observação"
                                                          :rows="3"
                                                          :max-rows="6">
                                         </b-form-textarea>
                                       </b-popover>
                                   </b-col>
                               </b-row>
                           </div>
                       </div>
                       <b-row class="pt-1">
                           <h3 class="header_destaque">Carga</h3>
                       </b-row>
                       <b-row>
                           <b-col class="p-0">
                               <label>Carga</label>
                               <multiselect v-model="form.param_carga"
                               :options="optionsParamTipoCarga"
                               track-by="value"
                               label="label"
                               :hide-selected="true"
                               placeholder="Selecione"
                               tag-placeholder="Selecionar"
                               select-label="Selecionar"
                               selected-label="Selecionado"
                               deselect-label="Remover"
                               ></multiselect>
                               <b-form-feedback v-text="form.errors.get('param_carga.value')" v-if="form.errors.has('param_carga.value')"></b-form-feedback>
                           </b-col>
                           <b-col class="p-0">
                               <label>Peso Cubado</label>
                               <currency-input
                                   class="form-control"
                                   v-model="valores.peso_cubado"
                                   placeholder="Peso cubado"
                                   :auto-decimal-mode="true"
                                   @change="getPesoUtilizado(valores)"
                                   :currency="{ prefix: 'm³ '}"
                                   :distraction-free="getCurrency"/>
                               <b-form-feedback v-text="form.errors.get('peso_cubado')" v-if="form.errors.has('peso_cubado')"></b-form-feedback>
                           </b-col>
                           <b-col class="p-0">
                               <label>Peso declarado</label>
                               <currency-input
                                   class="form-control"
                                   v-model="valores.peso_declarado"
                                   placeholder="Peso declarado"
                                   :auto-decimal-mode="true"
                                   :currency="{ prefix: 'Kg '}"
                                   @change="getPesoUtilizado(valores)"
                                   :distraction-free="getCurrency"/>
                               <b-form-feedback v-text="form.errors.get('peso_declarado')" v-if="form.errors.has('peso_declarado')"></b-form-feedback>
                           </b-col>
                           <b-col class="p-0">
                               <label>Qtde. Volume</label>
                               <currency-input
                                   class="form-control"
                                   v-model="valores.qtde_volume"
                                   placeholder="Qtde. volume"
                                   :auto-decimal-mode="true"
                                   :currency="{ prefix: ''}"
                                   :distraction-free="getCurrency"/>
                               <b-form-feedback v-text="form.errors.get('qtde_volume')" v-if="form.errors.has('qtde_volume')"></b-form-feedback>
                           </b-col>
                           <b-col class="p-0">
                               <label>Peso utilizado</label>
                               <currency-input
                                   class="form-control"
                                   v-model="valores.peso_utilizado"
                                   placeholder="Peso utilizado"
                                   disabled
                                   :auto-decimal-mode="true"
                                   :currency="{ prefix: ''}"
                                   :distraction-free="getCurrency"/>
                               <b-form-feedback v-text="form.errors.get('peso_utilizado')" v-if="form.errors.has('peso_utilizado')"></b-form-feedback>
                           </b-col>
                           <b-col class="p-0">
                               <label>Vlr. Total Mercadoria</label>
                               <currency-input
                                   class="form-control"
                                   v-model="valores.vlr_total_nfe"
                                   placeholder="Valor Total"
                                   :auto-decimal-mode="true"
                                   :currency="{ prefix: ''}"
                                   :distraction-free="getCurrency"/>
                               <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_total_nfe')" v-if="form.errors.has('vlr_total_nfe')"></b-form-feedback>
                           </b-col>
                       </b-row>
                   </b-container>
                   <b-container fluid>
                       <b-row v-bind:class="{ fullscreen_expand: isFullscreen }">
                            <div v-bind:class="{'col-md-7 col-sm-7': showMap, 'col-md-12 col-sm-12': !showMap}">
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="isLoadingTabelaFrete"><div class="loadingDataSpinner"><spinner v-if="isLoadingTabelaFrete" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                                        <div class="ml-0" v-for="(row, index) in trecho">
                                            <b-row :class="classSubtrecho(row)">
                                                <b-col class="col-lg-9 pl-0">
                                                    <h3 v-if="row.subtrecho==2" class="header_destaque">Trecho</h3>
                                                    <h3 v-if="row.subtrecho==1" class="header_destaque">Subtrecho</h3>
                                                </b-col>
                                                <b-col class="col-lg-3 pr-0 text-right">
                                                    <i v-if="row.modal.value!==6 && row.subtrecho==2" class="fa fa-plus pl-1" style="cursor: pointer" v-b-tooltip.hover.right="'Adicionar Trecho'" v-on:click="addRowTrecho();"></i>
                                                    <i v-if="row.modal.value==6" class="fa fa-plus-square-o pl-1" style="cursor: pointer" v-b-tooltip.hover.right="'Adicionar Subtrecho'" v-on:click="addRowSubTrecho($event);"></i>
                                                    <i @click="expandFullscreen()" v-b-tooltip class="ft-maximize  pl-1" title="Expande a tela" v-if="!isFullscreen"></i>
                                                    <i @click="expandFullscreen()" v-b-tooltip class="ft-minimize  pl-1" title="Expande a tela" v-if="isFullscreen"></i>
                                                    <i v-if="row.modal.value!==6"class="fa fa-calculator pl-1" style="cursor: pointer" v-b-tooltip.hover.right="'Calcular'" v-on:click="onGetTabelaFrete(index);"></i>
                                                    <i v-if="index!==0"class="fa fa-times pl-1" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowTrecho(index);"></i>
                                                    <i v-if="(index==0 && row.modal.value==6) || (index==0 && row.modal!==6)"class="fa fa-map-o pl-1" style="cursor: pointer" v-b-tooltip.hover.right="'Mostrar/Ocultar mapa'" v-on:click="toggleMap();"></i>
                                                </b-col>
                                            </b-row>
                                            <div class="loadingDataPositionEndereco">
                                                <div class="loadingData" v-if="isLoadingEnderecoOri"><div class="loadingDataSpinner"><spinner v-if="isLoadingEnderecoOri" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                                                <b-row>
                                                    <b-col class="p-0">
                                                        <label>CEP</label>
                                                        <b-form-input type="text"
                                                                      placeholder="CEP"
                                                                      v-model="row.cep_origem"
                                                                      name="cep_origem"
                                                                      v-mask="'########'"
                                                                      @change="getCep(index, 1)"
                                                                      >
                                                        </b-form-input>
                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.cep_origem')" v-if="form.errors.has('trecho.'+index+'.cep_origem')"></b-form-feedback>
                                                    </b-col>
                                                    <b-col class="p-0">
                                                        <label>Municipio</label>
                                                        <multiselect v-model="row.municipio_ori"
                                                        :options="optionsMunicipio"
                                                        track-by="value"
                                                        label="label"
                                                        :hide-selected="true"
                                                        placeholder="Selecione"
                                                        tag-placeholder=""
                                                        select-label=""
                                                        selected-label="Selecionado"
                                                        deselect-label="Remover"
                                                        @input="getUfMunicipio(index, row, 1)"
                                                        ></multiselect>
                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.municipio_ori.value')" v-if="form.errors.has('trecho.'+index+'.municipio_ori.value')"></b-form-feedback>
                                                    </b-col>
                                                    <b-col class="p-0">
                                                        <label>UF</label>
                                                        <b-form-input type="text"
                                                                      placeholder="UF"
                                                                      v-model="row.uf_ori"
                                                                      disabled
                                                                      >
                                                        </b-form-input>
                                                    </b-col>
                                                    <b-col  class="p-0">
                                                        <label>Endereço</label>
                                                        <b-form-input type="text"
                                                                      placeholder="Endereço"
                                                                      v-model="row.endereco_ori"
                                                                      name="endereco_ori"
                                                                      >
                                                        </b-form-input>
                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.endereco_ori')" v-if="form.errors.has('trecho.'+index+'.endereco_ori')"></b-form-feedback>
                                                    </b-col>
                                                    <b-col  class="p-0">
                                                        <label>Complemento</label>
                                                        <b-form-input type="text"
                                                                      placeholder="Complemento"
                                                                      v-model="row.complemento_ori"
                                                                      name="complemento_ori"
                                                                      >
                                                        </b-form-input>
                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.complemento_ori')" v-if="form.errors.has('trecho.'+index+'.complemento_ori')"></b-form-feedback>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                            <div class="loadingDataPositionEndereco">
                                                <div class="loadingData" v-if="isLoadingEnderecoDes"><div class="loadingDataSpinner"><spinner v-if="isLoadingEnderecoDes" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                                                <b-row>
                                                    <b-col  class="p-0">
                                                        <label>CEP</label>
                                                        <b-form-input type="text"
                                                                      placeholder="CEP"
                                                                      v-model="row.cep_destino"
                                                                      name="cep_destino"
                                                                      v-mask="'########'"
                                                                      @change="getCep(index, 2)"
                                                                      >
                                                        </b-form-input>
                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.cep_destino')" v-if="form.errors.has('trecho.'+index+'.cep_destino')"></b-form-feedback>
                                                    </b-col>
                                                    <b-col  class="p-0">
                                                        <label>Municipio</label>
                                                        <multiselect v-model="row.municipio_des"
                                                        :options="optionsMunicipio"
                                                        track-by="value"
                                                        label="label"
                                                        :hide-selected="true"
                                                        placeholder="Selecione"
                                                        tag-placeholder=""
                                                        select-label=""
                                                        selected-label="Selecionado"
                                                        deselect-label="Remover"
                                                        @input="getUfMunicipio(index, row, 2)"
                                                        ></multiselect>
                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.municipio_des.value')" v-if="form.errors.has('trecho.'+index+'.municipio_des.value')"></b-form-feedback>
                                                    </b-col>
                                                    <b-col  class="p-0">
                                                        <label>UF</label>
                                                        <b-form-input type="text"
                                                                      placeholder="UF"
                                                                      v-model="row.uf_des"
                                                                      disabled
                                                                      >
                                                        </b-form-input>
                                                    </b-col>
                                                    <b-col  class="p-0">
                                                        <label>Endereço</label>
                                                        <b-form-input type="text"
                                                                      placeholder="Endereço"
                                                                      v-model="row.endereco_des"
                                                                      name="endereco_des"
                                                                      >
                                                        </b-form-input>
                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.endereco_des')" v-if="form.errors.has('trecho.'+index+'.endereco_des')"></b-form-feedback>
                                                    </b-col>
                                                    <b-col  class="p-0">
                                                        <label>Complemento</label>
                                                        <b-form-input type="text"
                                                                      placeholder="Complemento"
                                                                      v-model="row.complemento_des"
                                                                      name="complemento_des"
                                                                      >
                                                        </b-form-input>
                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.complemento_des')" v-if="form.errors.has('trecho.'+index+'.complemento_des')"></b-form-feedback>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                            <b-row>
                                                <b-col sm="1" md="1" class="p-0">
                                                    <label>Ordem</label>
                                                    <b-form-input type="text"
                                                                  placeholder="Ordem"
                                                                  v-model="row.ordem"
                                                                  name="ordem"
                                                                  >
                                                    </b-form-input>
                                                    <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.ordem')" v-if="form.errors.has('trecho.'+index+'.ordem')"></b-form-feedback>
                                                </b-col>
                                                <b-col sm="3" md="3" class="p-0">
                                                    <label>Tipo Serviço</label>
                                                    <multiselect v-model="row.tp_servico"
                                                    :options="optionsTrechoTpServico"
                                                    track-by="value"
                                                    label="label"
                                                    :hide-selected="true"
                                                    placeholder="Selecione"
                                                    tag-placeholder=""
                                                    select-label=""
                                                    selected-label="Selecionado"
                                                    deselect-label="Remover"
                                                    ></multiselect>
                                                    <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.tp_servico.value')" v-if="form.errors.has('trecho.'+index+'.tp_servico.value')"></b-form-feedback>
                                                </b-col>
                                                <b-col sm="2" md="2" class="p-0">
                                                    <label>Carro.</label>
                                                    <multiselect v-model="row.carroceria"
                                                    :options="optionsParamCarroceria"
                                                    track-by="value"
                                                    label="label"
                                                    :hide-selected="true"
                                                    placeholder="Selecione"
                                                    tag-placeholder=""
                                                    select-label=""
                                                    selected-label="Selecionado"
                                                    deselect-label="Remover"
                                                    ></multiselect>
                                                    <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.carroceria.value')" v-if="form.errors.has('trecho.'+index+'.carroceria.value')"></b-form-feedback>
                                                </b-col>
                                                <b-col sm="2" md="2" class="p-0">
                                                    <label>Modal</label>
                                                    <multiselect v-model="row.modal"
                                                    :options="optionsModal"
                                                    track-by="value"
                                                    label="label"
                                                    :hide-selected="true"
                                                    placeholder="Selecione"
                                                    tag-placeholder=""
                                                    select-label=""
                                                    selected-label="Selecionado"
                                                    deselect-label="Remover"
                                                    @input="disableMultimodal(row.modal, index)"
                                                    ></multiselect>
                                                    <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.modal.value')" v-if="form.errors.has('trecho.'+index+'.modal.value')"></b-form-feedback>
                                                </b-col>
                                                <b-col v-if="row.modal.value!==6" class="p-0">
                                                    <label>Pedido</label>
                                                    <b-form-group>
                                                      <b-form-radio-group
                                                        v-model="row.tp_pedido"
                                                        :options="optionsTrechoTpPedido"
                                                        :name="'tp_pedido'+index"
                                                        stacked
                                                        plain
                                                      ></b-form-radio-group>
                                                    </b-form-group>
                                                    <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.tp_pedido')" v-if="form.errors.has('trecho.'+index+'.tp_pedido')"></b-form-feedback>
                                                </b-col>
                                                <b-col v-if="row.modal.value!==6" class="p-0">
                                                    <label>Trecho</label>
                                                    <b-form-group>
                                                      <b-form-radio-group
                                                        v-model="row.tp_trecho"
                                                        :options="optionsTrechoTpTrecho"
                                                        :name="'tp_trecho'+index"
                                                        stacked
                                                        plain
                                                      ></b-form-radio-group>
                                                    </b-form-group>
                                                    <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.tp_trecho')" v-if="form.errors.has('trecho.'+index+'.tp_trecho')"></b-form-feedback>
                                                </b-col>
                                                <b-col v-if="row.modal.value!==6" class="p-0">
                                                    <label>Coleta/Entrega</label>
                                                    <b-form-group>
                                                      <b-form-radio-group
                                                        v-model="row.tp_coleta_entrega"
                                                        :options="optionsTrechoTpColetaEntrega"
                                                        :name="'tp_coleta_entrega'+index"
                                                        stacked
                                                        plain
                                                      ></b-form-radio-group>
                                                    </b-form-group>
                                                    <b-form-feedback class="text-danger" v-text="form.errors.get('trecho.'+index+'.tp_coleta_entrega')" v-if="form.errors.has('trecho.'+index+'.tp_coleta_entrega')"></b-form-feedback>
                                                </b-col>
                                                <div>
                                                    <i id="popover-2" class="fa fa-commenting-o fa-2x" v-b-tooltip.hover.bottom="'Adicionar Observação'" tabindex="0" style="cursor: pointer"></i>
                                                    <b-popover placement="bottom" target="popover-2" variant="danger" triggers="focus">
                                                      <label class="panel-title">Observação</label>
                                                      <b-form-textarea id="textarea2"
                                                                       name="obs"
                                                                       v-model="row.obs"
                                                                       placeholder="Observação"
                                                                       :rows="3"
                                                                       :max-rows="6">
                                                      </b-form-textarea>
                                                    </b-popover>
                                                </div>
                                            </b-row>
                                        <div v-if="row.isVisibleTabela" class="table">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 10%"></th>
                                                            <th style="width: 10%">Código</th>
                                                            <th style="width: 35%">Descrição</th>
                                                            <th style="width: 35%">Valor Frete</th>
                                                            <th style="width: 10%">Ações</th>
                                                        </tr>
                                                     </thead>
                                                     <tbody>
                                                         <tr v-for="item in row.tabela_frete" class="bg-gray-light" style="display: table-row;">
                                                             <td>
                                                                 <b-form-group>
                                                                     <b-form-radio-group id="radio-group-2" v-model="row.tabfrevig_id" :name="'tabfrevig_'+index">
                                                                      <b-form-radio @change="getIcms(trecho, index, item.valores.valor_frete)" :value="item.tabfrevig_id"></b-form-radio>
                                                                    </b-form-radio-group>
                                                                </b-form-group>
                                                             </td>
                                                            <td>
                                                                {{item.tabela_frete.cd}}
                                                            </td>
                                                            <td>
                                                                {{item.tabela_frete.descr}}
                                                            </td>
                                                            <td>
                                                                {{formatNumber(item.valores.valor_frete)}}
                                                            </td>
                                                            <td>
                                                                <i class="fa fa-file-text-o" style="cursor: pointer" v-b-tooltip.hover.right="'Ver Detalhes'" v-on:click="onDetalhesTabelaFrete(item.tabfrevig_id);"></i>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5" v-if="showMap">
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="isLoadingMapa"><div class="loadingDataSpinner"><spinner v-if="isLoadingMapa" text-fg-color="#ffffff" message="Carregando..."></spinner></div></div>
                                    <b-embed
                                      type="iframe"
                                      aspect="16by9"
                                      v-bind:src="dados_mapa"
                                      allowfullscreen
                                    ></b-embed>
                                </div>
                            </div>
                        </b-row>
                    </b-container>
                    <b-container fluid>
                       <b-row>
                           <h3 class="header_destaque">Valores</h3>
                       </b-row>
                       <b-row>
                           <b-col class="p-0">
                               <label>Tipo CST</label>
                               <multiselect v-model="form.param_cst"
                               :options="optionsParamCst"
                               track-by="value"
                               label="label"
                               :hide-selected="true"
                               placeholder="Selecione"
                               tag-placeholder="Selecionar"
                               select-label="Selecionar"
                               selected-label="Selecionado"
                               deselect-label="Remover"
                               @input="getCdCst"
                               ></multiselect>
                               <b-form-feedback v-text="form.errors.get('param_cst.value')" v-if="form.errors.has('param_cst.value')"></b-form-feedback>
                           </b-col>
                           <b-col class="p-0">
                               <label>CST</label>
                               <b-form-input type="text"
                                             placeholder="CST"
                                             v-model="form.cst"
                                             name="cst"
                                             disabled
                                             >
                               </b-form-input>
                               <b-form-feedback v-text="form.errors.get('cst')" v-if="form.errors.has('cst')"></b-form-feedback>
                           </b-col>
                           <b-col class="p-0">
                               <label>Aliquota</label>
                               <currency-input
                                   class="form-control"
                                   v-model="valores.aliquota"
                                   placeholder="Alíquota"
                                   :auto-decimal-mode="true"
                                   :currency="{ prefix: '% '}"
                                   @change="ajustaValores(valores)"
                                   :distraction-free="getCurrency"/>
                               <b-form-feedback v-text="form.errors.get('aliquota')" v-if="form.errors.has('aliquota')"></b-form-feedback>
                           </b-col>
                       </b-row>
                       <b-row>

                           <b-col class="p-0">
                               <label>Perc. Desconto</label>
                               <currency-input
                                   class="form-control"
                                   v-model="valores.perc_desconto"
                                   placeholder="Perc. desconto"
                                   :auto-decimal-mode="true"
                                   :currency="{ prefix: '% '}"
                                   @change="ajustaValores(valores)"
                                   :distraction-free="getCurrency"/>
                               <b-form-feedback v-text="form.errors.get('perc_desconto')" v-if="form.errors.has('perc_desconto')"></b-form-feedback>
                           </b-col>
                           <b-col class="p-0">
                               <label>Vlr. Frete</label>
                               <currency-input
                                   class="form-control"
                                   v-model="valores.vlr_frete"
                                   placeholder="Valor frete"
                                   disabled
                                   :auto-decimal-mode="true"
                                   :currency="{ prefix: ''}"
                                   :distraction-free="getCurrency"/>
                               <b-form-feedback v-text="form.errors.get('vlr_frete')" v-if="form.errors.has('vlr_frete')"></b-form-feedback>
                           </b-col>
                           <b-col class="p-0">
                               <label>Vlr. Outros</label>
                               <currency-input
                                   class="form-control"
                                   v-model="valores.vlr_outros"
                                   placeholder="Vlr. outros"
                                   :auto-decimal-mode="true"
                                   :currency="{ prefix: ''}"
                                   @change="ajustaValores(valores)"
                                   :distraction-free="getCurrency"/>
                               <b-form-feedback v-text="form.errors.get('vlr_outros')" v-if="form.errors.has('vlr_outros')"></b-form-feedback>
                           </b-col>
                           <b-col class="p-0">
                               <label>Vlr. Imposto</label>
                               <currency-input
                                   class="form-control"
                                   v-model="valores.vlr_imposto"
                                   placeholder="Vlr. imposto"
                                   disabled
                                   :auto-decimal-mode="true"
                                   :currency="{ prefix: ''}"
                                   :distraction-free="getCurrency"/>
                               <b-form-feedback v-text="form.errors.get('vlr_imposto')" v-if="form.errors.has('vlr_imposto')"></b-form-feedback>
                           </b-col>
                           <b-col class="p-0">
                               <label>Vlr. Desconto</label>
                               <currency-input
                                   class="form-control"
                                   v-model="valores.vlr_desconto"
                                   placeholder="Vlr. desconto"
                                   disabled
                                   :auto-decimal-mode="true"
                                   :currency="{ prefix: ''}"
                                   :distraction-free="getCurrency"/>
                               <b-form-feedback v-text="form.errors.get('vlr_desconto')" v-if="form.errors.has('vlr_desconto')"></b-form-feedback>
                           </b-col>
                           <b-col class="p-0">
                               <label>Vlr. Cotação</label>
                               <currency-input
                               class="form-control"
                               v-model="valores.vlr_total"
                               placeholder="Valor Total"
                               disabled
                               :auto-decimal-mode="true"
                               :currency="{ prefix: ''}"
                               :distraction-free="getCurrency"/>
                               <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_total')" v-if="form.errors.has('vlr_total')"></b-form-feedback>
                           </b-col>
                       </b-row>
                       <b-row>
                           <div class="col-md-12" role="tablist">
                               <b-card-header header-tag="header" class="p-1" role="tab">
                                  <b-button block href="#" v-b-toggle.accordion-1>Outros Valores</b-button>
                                </b-card-header>
                              <b-collapse  id="accordion-1" accordion="my-accordion" role="tabpanel">
                                  <b-container fluid>
                                      <b-row>
                                        <b-col class="p-0">
                                            <label>Perc. redução BC</label>
                                            <currency-input
                                                class="form-control"
                                                v-model="valores.perc_reducao_bc"
                                                placeholder="Perc. redução BC"
                                                disabled
                                                :auto-decimal-mode="true"
                                                :currency="{ prefix: '% '}"
                                                :distraction-free="getCurrency"/>
                                            <b-form-feedback v-text="form.errors.get('perc_reducao_bc')" v-if="form.errors.has('perc_reducao_bc')"></b-form-feedback>
                                        </b-col>
                                        <b-col class="p-0">
                                            <label>Vlr. BC ST Retido</label>
                                            <currency-input
                                                class="form-control"
                                                v-model="valores.vlr_bc_st_retido"
                                                placeholder="Vlr. BC ST retido"
                                                disabled
                                                :auto-decimal-mode="true"
                                                :currency="{ prefix: ''}"
                                                :distraction-free="getCurrency"/>
                                            <b-form-feedback v-text="form.errors.get('vlc_bc_st_retido')" v-if="form.errors.has('vlc_bc_st_retido')"></b-form-feedback>
                                        </b-col>
                                        <b-col class="p-0">
                                            <label>Vlr. Imp. ST Retido</label>
                                            <currency-input
                                                class="form-control"
                                                v-model="valores.vlr_imposto_st_retido"
                                                placeholder="Vlr. imposto ST retido"
                                                disabled
                                                :auto-decimal-mode="true"
                                                :currency="{ prefix: ''}"
                                                :distraction-free="getCurrency"/>
                                            <b-form-feedback v-text="form.errors.get('vlr_imposto_st_retido')" v-if="form.errors.has('vlr_imposto_st_retido')"></b-form-feedback>
                                        </b-col>
                                        <b-col class="p-0">
                                            <label>Vlr. Cre. Presumido</label>
                                            <currency-input
                                                class="form-control"
                                                v-model="valores.vlr_credito_presumido"
                                                placeholder="Vlr. credito presumido"
                                                disabled
                                                :auto-decimal-mode="true"
                                                :currency="{ prefix: ''}"
                                                :distraction-free="getCurrency"/>
                                            <b-form-feedback v-text="form.errors.get('vlr_credito_presumido')" v-if="form.errors.has('vlr_credito_presumido')"></b-form-feedback>
                                        </b-col>
                                    </b-row>
                                </b-container>
                              </b-collapse>
                            </div>
                       </b-row>
                   </b-container>
                   <b-container fluid>
                       <b-row>
                           <b-col class="p-0">
                               <br/>
                               <h3 class="panel-title">Detalhes</h3>
                               <b-tabs>
                                   <b-tab title="Contato" active>
                                       <div class="table">
                                           <table class="table">
                                               <thead>
                                                   <tr>
                                                       <th style="width: 30%">Nome</th>
                                                       <th style="width: 30%">Email</th>
                                                       <th style="width: 30%">Telefone</th>
                                                       <th style="width: 10%">Ações</th>
                                                   </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(row, index) in contato" class="bg-gray-light" style="display: table-row;">
                                                       <td>
                                                           <b-col class="p-0">
                                                               <label>Nome</label>
                                                               <b-form-input type="text"
                                                                             placeholder="Nome"
                                                                             v-model="row.nome"
                                                                             name="nome"
                                                                             >
                                                               </b-form-input>
                                                               <b-form-feedback class="text-danger" v-text="form.errors.get('contato.'+index+'.nome')" v-if="form.errors.has('contato.'+index+'.nome')"></b-form-feedback>
                                                           </b-col>
                                                       </td>
                                                       <td>
                                                           <b-col class="p-0">
                                                               <label>E-mail</label>
                                                               <b-form-input type="text"
                                                                             placeholder="E-mail"
                                                                             v-model="row.email"
                                                                             name="email"
                                                                             >
                                                               </b-form-input>
                                                               <b-form-feedback class="text-danger" v-text="form.errors.get('contato.'+index+'.email')" v-if="form.errors.has('contato.'+index+'.email')"></b-form-feedback>
                                                           </b-col>
                                                       </td>
                                                       <td>
                                                           <b-col class="p-0">
                                                               <label>Telefone</label>
                                                               <b-form-input type="text"
                                                                             placeholder="Telefone"
                                                                             v-model="row.telefone"
                                                                             name="telefone"
                                                                             >
                                                               </b-form-input>
                                                               <b-form-feedback class="text-danger" v-text="form.errors.get('contato.'+index+'.telefone')" v-if="form.errors.has('contato.'+index+'.telefone')"></b-form-feedback>
                                                           </b-col>
                                                       </td>
                                                       <td>
                                                             <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowContato(index);"></i>
                                                       </td>
                                                   </tr>
                                               </tbody>
                                               <td colspan="3"></td>
                                               <td>
                                                 <i class="fa fa-plus-square" v-on:click="addRowContato($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                               </td>
                                           </table>
                                       </div>
                                   </b-tab>
                                   <b-tab title="Docs.">
                                       <div class="table-responsive">
                                           <table class="table">
                                               <thead>
                                                   <tr>
                                                     <th style="width: 5%">Tipo</th>
                                                     <th style="width: 30%">Doc Carga - Emitente</th>
                                                     <th style="width: 15%">Chave</th>
                                                     <th style="width: 10%">Nº Fiscal</th>
                                                     <th style="width: 10%">Série</th>
                                                     <th style="width: 8%">Data</th>
                                                     <th style="width: 7%">Valor</th>
                                                     <th style="width: 5%">Ação</th>
                                                 </tr>
                                              </thead>
                                              <tbody>
                                                  <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in docfis">
                                                     <td>
                                                         {{ row.tp_doc.descr }}
                                                     </td>
                                                     <td>
                                                         {{ row.emi_nome }}
                                                     </td>
                                                     <td>
                                                         <span v-if="row.tp_doc.valor==1">
                                                             <b-btn class="badge badge-warning" @click="showPopoverChaveNFe = !showPopoverChaveNFe" :id="'popoverButtonChaveNFe-sync'+row.chave" v-b-tooltip.hover.right="'Clique aqui para ver a chave completa ( Todas )'" variant="warning">{{ row.chave.substr(34,10) }}</b-btn>

                                                               <b-popover :show.sync="showPopoverChaveNFe" :target="'popoverButtonChaveNFe-sync'+row.chave" title="" data-html="true" placement="top">
                                                                   {{ row.chave }}
                                                               </b-popover>
                                                         </span>
                                                     </td>
                                                     <td>
                                                         {{ row.num_fiscal }}
                                                     </td>
                                                     <td>
                                                         {{ row.serie }}
                                                     </td>
                                                     <td>
                                                         <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                                     </td>
                                                     <td>
                                                         {{ formatNumber(row.vlr_total) }}
                                                     </td>
                                                     <td>
                                                         <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDoc(index);"></i>
                                                     </td>
                                                 </tr>
                                             </tbody>
                                         </table>
                                     </div>
                                     <b-tabs style="width: 100%">
                                         <b-tab title="NFe" active>
                                             <b-container fluid>
                                                 <b-row>
                                                     <b-col sm="8" md="8" class="m-t-5px">
                                                         <label>Chave NFe</label>
                                                         <b-form-input type="text"
                                                                      placeholder="Chave NFe"
                                                                      v-model="helpForm.chave"
                                                                      >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('chave')" v-if="helpForm.errors.has('chave')"></b-form-feedback>
                                                     </b-col>
                                                     <b-col sm="4" md="4" class="m-t-5px">
                                                         <div class="float-right">
                                                             <label> - </label>

                                                             <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDoc(1);" v-b-tooltip.hover.right="'Adicionar NFe'" style="cursor: pointer">
                                                             Adicionar
                                                             </b-btn>

                                                             <b-btn variant="secondary" :disabled="isDisabled" v-on:click="onBuscarDoc();" v-b-tooltip.hover.right="'Buscar Doc'" style="cursor: pointer">
                                                             Buscar
                                                             </b-btn>
                                                         </div>
                                                     </b-col>

                                                 </b-row>
                                             </b-container>
                                         </b-tab>
                                         <b-tab title="CTe">
                                             <b-container fluid>
                                                 <b-row>
                                                     <b-col sm="10" md="10" class="m-t-5px">
                                                         <label>Chave CTe</label>
                                                         <b-form-input type="text"
                                                                      placeholder="Chave CTe"
                                                                      v-model="helpForm.chave"
                                                                      >
                                                         </b-form-input>
                                                         <b-form-feedback class="text-danger" v-text="helpForm.errors.get('chave')" v-if="helpForm.errors.has('chave')"></b-form-feedback>
                                                     </b-col>
                                                     <b-col sm="2" md="2" class="m-t-5px">
                                                         <label> - </label>
                                                         <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDocTransp(1);" v-b-tooltip.hover.right="'Adicionar CTe'" style="cursor: pointer">
                                                         Adicionar
                                                         </b-btn>
                                                     </b-col>
                                                 </b-row>
                                             </b-container>
                                         </b-tab>
                                     </b-tabs>
                                   </b-tab>
                                   <b-tab title="Regra Fiscal">
                                       <div class="table">
                                           <table class="table">
                                               <thead>
                                                   <tr>
                                                       <th style="width: 45%">Ordem</th>
                                                       <th style="width: 45%">Regra</th>
                                                       <th style="width: 10%">Ações</th>
                                                   </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(row, index) in regra_fiscal" class="bg-gray-light" style="display: table-row;">
                                                       <td>
                                                           <b-col class="p-0">
                                                               <label>Ordem</label>
                                                               <b-form-input type="text"
                                                                             placeholder="Ordem"
                                                                             v-model="row.ordem"
                                                                             name="ordem"
                                                                             >
                                                               </b-form-input>
                                                               <b-form-feedback class="text-danger" v-text="form.errors.get('regra_fiscal.'+index+'.ordem')" v-if="form.errors.has('regra_fiscal.'+index+'.ordem')"></b-form-feedback>
                                                           </b-col>
                                                       </td>
                                                       <td>
                                                           <b-col class="p-0">
                                                               <label>Regra Fiscal</label>
                                                               <multiselect v-model="row.regra"
                                                               :options="optionsRegraFiscal"
                                                               track-by="value"
                                                               label="label"
                                                               :hide-selected="true"
                                                               placeholder="Selecione"
                                                               tag-placeholder="Selecionar"
                                                               select-label="Selecionar"
                                                               selected-label="Selecionado"
                                                               deselect-label="Remover"
                                                               ></multiselect>
                                                               <b-form-feedback class="text-danger" v-text="form.errors.get('regra_fiscal.'+index+'.regra.value')" v-if="form.errors.has('regra_fiscal.'+index+'.regra.value')"></b-form-feedback>
                                                           </b-col>
                                                       </td>
                                                       <td>
                                                             <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowRegraFiscal(index);"></i>
                                                       </td>
                                                   </tr>
                                               </tbody>
                                               <td colspan="2"></td>
                                               <td>
                                                 <i class="fa fa-plus-square" v-on:click="addRowRegraFiscal($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                               </td>
                                           </table>
                                       </div>
                                   </b-tab>
                               </b-tabs>
                           </b-col>
                       </b-row>

                   </b-container>
               </form>
               <div slot="modal-footer" class="w-100">
                      <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                      <div class="float-right">
                          <div class="float-left" v-if="this.errors_array.length>0">
                              <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

                                <b-popover :show.sync="showPopover" target="popoverButton-sync" title="Erros Encontrados" data-html="true" placement="leftbottom">
                                  <table class="table-striped" id="mais">
                                       <tbody>
                                           <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                                              <td>
                                                {{ item.erro }}
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table>
                                </b-popover>
                            </div>
                          <b-btn @click="showModal=false" variant="secondary">
                            Fechar
                          </b-btn>
                          <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                            Enviar
                          </b-btn>
                      </div>
               </div>
            </b-modal>
                  <DetalhesTabelaFrete
                    ref="detalhestabelafrete">
                  </DetalhesTabelaFrete>
                  <BuscarDocFiscal
                    ref="buscardocfiscal">
                  </BuscarDocFiscal>
                  <PedidoForm
                      ref="pedidoform">
                  </PedidoForm>
              </div>
          </div>
</template>
<script>
import DetalhesTabelaFrete from './DetalhesTabelaFrete'
import BuscarDocFiscal from '../components/BuscarDocFiscal'
import PedidoForm from '../components/PedidoForm'
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import CotacaoFilterBar from './CotacaoFilterBar'
import CotacaoDetalhes from './CotacaoDetalhes'
import accounting from 'accounting'
import moment from 'moment'

Vue.component('cotacao-detalhes', CotacaoDetalhes);

export default {
components: {
    Vuetable,
    VuetablePagination,
    PedidoForm,
    DetalhesTabelaFrete,
    VuetablePaginationInfo,
    BuscarDocFiscal,
    'vuetable-filterbar': CotacaoFilterBar
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      isLoadingPessoa: false,
      loadingCep: false,
      isLoadingEnderecoOri: false,
      isLoadingEnderecoDes: false,
      isLoadingMapa: false,
      isLoadingTabelaFrete: false,
      isVisibleTabela: false,
      showPopoverChaveNFe: false,
      showPopover: false,
      showMap: true,
      mapa: 2,
      dados_mapa: 'https://www.google.com/maps/embed/v1/view?key=AIzaSyCT3QaWzQaKokuqPLkaR9tz10qRG_FCp90&center=-16.840434,-57.471702&zoom=3',
      tp_carga: 3,
      trecho_custo: [],
      subtrechos: [],
      optionsCotacaoStatus: [],
      optionsCotacaoOrigem: [],
      optionsCotacaoTpCarga: [],
      optionsCotacaoTomador: [],
      optionsTrechoTpServico: [],
      optionsTrechoTpPedido: [],
      optionsTrechoTpColetaEntrega: [],
      dados_pedido: [],
      optionsDocTpDoc: [],
      optionsMunicipio: [],
      optionsParamCst: [],
      optionsParamTipoCarga: [],
      optionsTrechoTpTrecho: [],
      optionsPessoa: [],
      optionsModal: [],
      optionsTabelaFrete: [],
      optionsRegraFiscal: [],
      errors_array: [],
      docfis: [],
      doctransp: [],
      optionsParamCarroceria: [],
      valores: {vlr_total_nfe: 0,
                vlr_total: 0,
                valor_frete: 0,
                peso_cubado: 0,
                peso_declarado: 0,
                qtde_volume: 0,
                peso_utilizado: 0,
                aliquota: 0,
                perc_desconto: 0,
                vlr_frete: 0,
                vlr_imposto: 0,
                vlr_desconto: 0,
                vlr_outros: 0,
                perc_reducao_bc: 0,
                vlr_bc_st_retido: 0,
                vlr_imposto_st_retido: 0,
                distancia_mapa: 0,
                vlr_credito_presumido: 0,
                cotval_id: ''},
      contato: [{
                 nome: '',
                 email: '',
                 telefone: '',
                 cotcon_id: '',
             }],
     regra_fiscal: [{
                ordem: '',
                regra: [],
                cotregfis_id: '',
            }],
     trecho: [{
             valor_frete_individual: 0,
             vlr_frete: 0,
             cep_origem: '',
             municipio_ori: [],
             endereco_ori: '',
             complemento_ori: '',
             cep_destino: '',
             uf_ori: '',
             uf_des: '',
             municipio_des: [],
             endereco_des: '',
             complemento_des: '',
             ordem: '',
             tp_servico: [],
             carroceria: [],
             tp_pedido: '',
             tp_trecho: '',
             tp_coleta_entrega: '',
             modal: [],
             tab_frete: [],
             obs: '',
             tabfrevig_id: '',
             subtrecho: 2,
             distancia: '',
             index: 0,
             tabela_frete: [],
             cottre_id: '',
           }],
       form_cotacao: new Form({
           cotacao_id: ''
       }),
      form: new Form({ descr: '',
                        pessoa_origem: [],
                        pessoa_destino: [],
                        param_carga: [],
                        tp_carga: '',
                        tomador: '',
                        obs: '',
                        contato: [],
                        regra_fiscal: [],
                        trecho: [],
                        param_cst: [],
                        valores: {},
                        cst: '',
                        tp_busca_tabela: '',
                        docfis: [],
                        cotacao_id: ''

                   }),
     helpFormIcms: new Form({municipio_ori_id: '', municipio_des_id: ''}),
     helpForm: new Form({statusRecord: [],search: '', cep_busca: '', pessoa_id: '', params: []
                       , docs: []
                       , doctransp: []
                       , chave: ''
                       , distancia_mapa: ''
                       , globalizado: ''}),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'num_cotacao',
        title: 'N° Cotação',
        sortField: 'num_cotacao'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: 'param_tipo_carga.descr',
        title: 'Tipo Carga'
      },
      {
          name: 'vlr_total',
          title: 'Valor',
          callback: 'formatNumber'
      },
      {
        name: '__slot:tomador',
        title: 'Tomador',
        sortField: 'tomador'
      },
      {
        name: '__slot:pessoa_origem',
        title: 'Origem'
      },
      {
        name: '__slot:tp_carga',
        title: 'Tipo',
        sortField: 'tp_carga'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
mounted() {
    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
    this.$events.$on('filter-reset', e => this.onFilterReset());
    this.getLivGeral();
  },
methods: {
    expandFullscreen() {
        this.isFullscreen = !this.isFullscreen;
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onFilterSet (data_filter) {
        this.loadingData = true;
        this.moreParams = {
            'num_cotacao': data_filter.num_cotacao,
            'descr': data_filter.descr,
            'pessoa_origem': data_filter.pessoa_origem.value,
            'pessoa_destino': data_filter.pessoa_destino.value,
            'status': data_filter.status.value
        }
        Vue.nextTick( () => {this.$refs.vuetable.reload(); })
    },
    onFilterReset () {
        this.loadingData = true;
        this.moreParams = {}
        Vue.nextTick( () => this.$refs.vuetable.refresh())
    },
    onFilterShowHide() {
        if(this.vuetableFilterRow)
        {
            this.$store.commit('setVuetableFilterRow', false);
        }
        else
        {
            this.$store.commit('setVuetableFilterRow', true);
        }
    },
    onLoaded: function () {
        this.dataExport = this.$refs.vuetable.tableData;
        this.loadingData = false;
        this.$store.commit('setVuetableFilterButton', false);
    },
    onBuscarDoc(data)     {
        this.$refs.buscardocfiscal.onBuscarDocFiscal(data); // PedidoUnidadeCarga
    },
    onEditPedido(data)
    {console.log(data);
        this.dados_pedido = null;
        this.dados_pedido = [];
        this.dados_pedido.subtrechos = null;
        this.dados_pedido.subtrechos = [];
        this.dados_pedido.descr = 'Teste';
        this.dados_pedido.dt_pedido = '';
        this.dados_pedido.produto_predominante = '';
        this.dados_pedido.percentual_advalorem = '';
        this.dados_pedido.obs = data.obs;
        this.dados_pedido.obs_cte = '';
        this.dados_pedido.obs_cte_fiscal = '';
        this.dados_pedido.qtde_uc = '';
        this.dados_pedido.b_modal = null;
        this.dados_pedido.cfop = null;
        this.dados_pedido.param_cst = data.cotacao_valor.param_cst;
        this.dados_pedido.pedido_tomador = data.tomador;
        this.dados_pedido.municipio_inicio = null;//foreach
        this.dados_pedido.municipio_fim = null;//foreach
        this.dados_pedido.tp_pedido = null;//rever
        this.dados_pedido.tp_servico = null;//rever
        this.dados_pedido.tp_carga = null;//rever
        this.dados_pedido.tp_fronteira = null;
        this.dados_pedido.exibe_advalorem_cfrete = null;
        this.dados_pedido.tp_valor_advalorem = null;//Aberto
        this.dados_pedido.tp_valor_carga = null;// Aberto
        this.dados_pedido.permite_adicionar_uc = null;//Aberto
        this.dados_pedido.imposto_incluso = null;//Aberto
        //this.dados_pedido.pessoa.pessoa_juridica = null;
        this.dados_pedido.pedido_param_seguro = null;
        this.dados_pedido.pedido_param_trecho = [];
        this.dados_pedido.pedido_param_comp_frete = null;
        this.dados_pedido.pedido_param_trecho_receita = null;
        data.cotacao_trecho.reverse().forEach((item, i) => {
            this.trecho_custo = null;
            this.trecho_custo = [];
            if(item.subtrecho==1)
            {
                item.cotacao_trecho_custo.forEach((item2, i2) => {
                    if(item.cottre_id == item2.cottre_id)
                    {
                        this.trecho_custo.push({
                            pedpartrc_id: item2.cottre_id,
                            custo: {label: item2.custo.descr, value: item2.custo.valor},
                            tp_custo_trecho: {label: item2.custo.descr, value: item2.custo.valor},
                            valor: item2.vlr_total,
                            descr: item2.custo.descr,
                        })
                    }
                });
                this.dados_pedido.subtrechos.push({
                    fornecedor: item.tabela_frete_vigencia.tabela_frete.fornecedor,
                    pedpartre_id: item.cottre_id,
                    pedido_param_custo: this.trecho_custo,
                    tp_trecho: {descr: item.tp_trecho.descr, valor: item.tp_trecho.valor},
                    tp_trecho_custo: {descr: item.tp_trecho.descr, valor: item.tp_trecho.valor},//rever
                    b_modal: {descr: item.b_modal.descr, valor: item.b_modal.bmodal_id},
                    municipio_inicio: {nome: item.municipio_origem.nome, valor: item.municipio_origem.municipio_id},
                    municipio_fim: {nome: item.municipio_destino.nome, valor: item.municipio_destino.municipio_id},
                    ordem: item.ordem,
                    principal: 1,//ajustar
                    advalorem: 10,//ajustar
                    subtrecho: 1,
                    subtrechos_tmp: [],
                    subtrechos: []
                })
            }
            else
            {
                item.cotacao_trecho_custo.forEach((item2, i2) => {
                    if(item.cottre_id == item2.cottre_id)
                    {
                        this.trecho_custo.push({
                            pedpartrc_id: item2.cottre_id,
                            custo: {label: item2.custo.descr, value: item2.custo.valor},
                            tp_custo_trecho: {label: item2.custo.descr, value: item2.custo.valor},
                            valor: item2.vlr_total,
                            descr: item2.custo.descr,
                        })
                    }
                });
                //Caso seja multimodal não tem tabela_frete, e não existe subtrecho multimodal
                if(item.b_modal.cd!=6)
                {
                  this.vn_fornecedor = item.tabela_frete_vigencia.tabela_frete.fornecedor;
                }
                else
                {
                  this.vn_fornecedor = null;
                }
                this.dados_pedido.pedido_param_trecho.push({
                    fornecedor: this.vn_fornecedor,
                    pedido_param_trecho_custo: this.trecho_custo,
                    pedpartre_id: item.cottre_id,
                    tp_trecho: {descr: item.tp_trecho.descr, valor: item.tp_trecho.valor},
                    tp_trecho_custo: {descr: item.tp_trecho.descr, valor: item.tp_trecho.valor},//rever
                    b_modal: {descr: item.b_modal.descr, valor: item.b_modal.bmodal_id},
                    municipio_inicio: {nome: item.municipio_origem.nome, valor: item.municipio_origem.municipio_id},
                    municipio_fim: {nome: item.municipio_destino.nome, valor: item.municipio_destino.municipio_id},
                    ordem: item.ordem,
                    principal: 1,//ajustar
                    advalorem: 10,//ajustar
                    subtrecho: 2,
                    subtrechos_tmp: this.dados_pedido.subtrechos,
                    subtrechos: this.dados_pedido.subtrechos
                })
            }
        });
        this.$refs.pedidoform.onEdit(this.dados_pedido, null);
    },
    addDoc(tipo) {
        this.loadingAddDoc = true;
        this.isDisabledAddDoc = true;
        this.helpForm.docs = this.docfis;
        this.helpForm.globalizado = 1;
        this.helpForm.post('/api/associar/adddoc').then(response =>
        {
            this.docfis.push({
                id: response.docfis_id,
                chave: response.chave,
                num_fiscal: response.num_fiscal,
                serie: response.serie,
                dt_emissao: response.dt_emissao,
                emi_nome: response.doc_fiscal_partes_env.emi_nome,
                emi_cnpj: response.doc_fiscal_partes_env.emi_cnpj,
                des_nome: response.doc_fiscal_partes_env.des_nome,
                des_cnpj: response.doc_fiscal_partes_env.des_cnpj,
                tp_doc: response.liv_tp_doc,
                tp_doc_descr: response.liv_tp_doc.label,
                vlr_total: response.doc_fiscal_vlr_total.vlr_total_nfe,
            });
            if(tipo==1)//Adicionar
            {
                this.populaValores();
                this.ajustaValores(this.valores);
            }
            this.loadingAddDoc = false;
            this.isDisabledAddDoc = false;
            this.helpForm.chave = "";
            new ReturnApi(response, this);
        })
        .catch(errors =>
        {
            this.loadingAddDoc = false;
            this.isDisabledAddDoc = false;
            new ReturnApi(errors, this)
        });
    },
    addDocTransp(tipo) {
        this.loadingAddDoc = true;
        this.isDisabledAddDoc = true;
        this.helpForm.doctransp = this.doctransp;
        this.helpForm.post('/api/associar/adddoctransp').then(response =>
        {
            this.vn_vlr_carga = 0;
            response.doc_transp_inf_carga.forEach((obj)=>{
                this.vn_vlr_carga = obj.vlr_total_carga+this.vn_vlr_carga;
            });
            this.docfis.push({
                id: response.doctransp_id,
                chave: response.chave,
                num_fiscal: response.num_doc,
                serie: response.serie,
                dt_emissao: response.dt_emissao,
                emi_nome: response.doc_transp_partes_env.emi_nome,
                emi_cnpj: response.doc_transp_partes_env.emi_cnpj,
                des_nome: response.doc_transp_partes_env.des_nome,
                des_cnpj: response.doc_transp_partes_env.des_cnpj,
                tp_doc: response.liv_tp_doc,
                tp_doc_descr: response.liv_tp_doc.label,
                vlr_total: this.vn_vlr_carga,
            });
            if(tipo==1)//Adicionar
            {
                this.populaValores();
            }
            this.loadingAddDoc = false;
            this.isDisabledAddDoc = false;
            new ReturnApi(response, this);
        })
        .catch(errors =>
        {
            this.loadingAddDoc = false;
            this.isDisabledAddDoc = false;
            new ReturnApi(errors, this)
        });
    },
    populaValores() {
        this.vn_vlr_total_cotacao = 0;
        this.docfis.forEach((obj)=>{
            this.vn_vlr_total_cotacao = parseFloat(obj.vlr_total)+parseFloat(this.vn_vlr_total_cotacao);
        });
        this.valores.vlr_total_nfe = this.vn_vlr_total_cotacao;
    },
    onVoltarDetalhes(data) {console.log(data);
          this.valores.vlr_total_nfe            = data.valores.vlr_total_nfe;
          this.valores.peso_cubado              = data.valores.peso_cubado;
          this.valores.peso_declarado           = data.valores.peso_declarado;
          this.valores.qtde_volume              = data.valores.qtde_volume;
          this.valores.peso_utilizado           = data.valores.peso_utilizado;
          this.$refs.modal_form.show();
    },
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.cotacao_id);
        }
    },
    onCreate ()
    {
        this.isLoadingTabelaFrete = false;
      this.form.vlr_total_nfe = 0;
      this.form.vlr_total = 0;
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.form.tp_carga = 1; //Normal
      this.form.tomador = 3; //Destinatario
      this.trecho[0].tp_pedido = 1; //Lotacao
      this.trecho[0].tp_trecho = 1; //Normal
      this.trecho[0].tp_coleta_entrega = 1; //No Cliente
      this.errors_array = '';
      this.errors_array = [];
      this.contato       = '';
      this.contato       = [];
      this.trecho        = '';
      this.trecho        = [];
      this.regra_fiscal  = '';
      this.regra_fiscal  = [];
      this.docfis        = '';
      this.docfis        = [];
      this.valores.peso_cubado = parseInt(0, 10);
      this.valores.peso_declarado = parseInt(0, 10);
      this.valores.qtde_volume = parseInt(0, 10);
      this.valores.peso_utilizado = parseInt(0, 10);
      this.valores.vlr_total_nfe = parseInt(0, 10);
      this.valores.aliquota = parseInt(0, 10);
      this.valores.perc_desconto = parseInt(0, 10);
      this.valores.vlr_frete = parseInt(0, 10);
      this.valores.vlr_outros = parseInt(0, 10);
      this.valores.vlr_imposto = parseInt(0, 10);
      this.valores.vlr_desconto = parseInt(0, 10);
      this.valores.vlr_total = parseInt(0, 10);
      this.valores.perc_reducao_bc = parseInt(0, 10);
      this.valores.vlr_bc_st_retido = parseInt(0, 10);
      this.valores.vlr_imposto_st_retido = parseInt(0, 10);
      this.valores.vlr_credito_presumido = parseInt(0, 10);
      this.addRowTrecho();
      this.$refs.modal_form.show();
    },
    onEdit (data, index)
    {console.log(data);
      this.isLoadingTabelaFrete = false;
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar Cotação";
      this.modal_botao = "Alterar Cotação";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.contato       = '';
      this.contato       = [];
      this.trecho        = '';
      this.trecho        = [];
      this.regra_fiscal  = '';
      this.regra_fiscal  = [];
      this.docfis        = '';
      this.docfis        = [];
      this.valores.peso_cubado = parseInt(0, 10);
      this.valores.peso_declarado = parseInt(0, 10);
      this.valores.qtde_volume = parseInt(0, 10);
      this.valores.peso_utilizado = parseInt(0, 10);
      this.valores.vlr_total_nfe = parseInt(0, 10);
      this.valores.aliquota = parseInt(0, 10);
      this.valores.perc_desconto = parseInt(0, 10);
      this.valores.vlr_frete = parseInt(0, 10);
      this.valores.vlr_outros = parseInt(0, 10);
      this.valores.vlr_imposto = parseInt(0, 10);
      this.valores.vlr_desconto = parseInt(0, 10);
      this.valores.vlr_total = parseInt(0, 10);
      this.valores.perc_reducao_bc = parseInt(0, 10);
      this.valores.vlr_bc_st_retido = parseInt(0, 10);
      this.valores.vlr_imposto_st_retido = parseInt(0, 10);
      this.valores.vlr_credito_presumido = parseInt(0, 10);
      this.form.descr = data.descr;
      this.form.tp_carga = data.tp_carga.valor;
      this.form.tomador = data.tomador.valor;
      if(data.pessoa_origem!==null)
      {
          if(data.pessoa_origem.pessoa_fisica!==null)
          {
              this.form.pessoa_origem = {label: "PF -"+data.pessoa_origem.pessoa_fisica.nome+" - "+data.pessoa_origem.pessoa_fisica.cpf, value: data.pessoa_origem.pessoa_id}
          }
          else if(data.pessoa_origem.pessoa_juridica!==null)
          {
              this.form.pessoa_origem = {label: "PJ -"+data.pessoa_origem.cd+" - "+data.pessoa_origem.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(data.pessoa_origem.pessoa_juridica.cnpj_base,data.pessoa_origem.pessoa_juridica.cnpj_filial,data.pessoa_origem.pessoa_juridica.cnpj_digito)+" - "+data.pessoa_origem.pessoa_juridica.inscricao_estadual, value: data.pessoa_origem.pessoa_id}
          }
          else if(data.pessoa_origem.pessoa_exterior!==null)
          {
              this.form.pessoa_origem = {label: "PE -"+data.pessoa_origem.pessoa_exterior.nome+" - "+data.pessoa_origem.pessoa_exterior.cd, value: data.pessoa_origem.pessoa_id}
          }

      }
      if(data.pessoa_destino!==null)
      {
          if(data.pessoa_destino.pessoa_fisica!==null)
          {
              this.form.pessoa_destino = {label: "PF -"+data.pessoa_destino.pessoa_fisica.nome+" - "+data.pessoa_destino.pessoa_fisica.cpf, value: data.pessoa_destino.pessoa_id}
          }
          else if(data.pessoa_destino.pessoa_juridica!==null)
          {
              this.form.pessoa_destino = {label: "PJ -"+data.pessoa_destino.cd+" - "+data.pessoa_destino.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(data.pessoa_destino.pessoa_juridica.cnpj_base,data.pessoa_destino.pessoa_juridica.cnpj_filial,data.pessoa_destino.pessoa_juridica.cnpj_digito)+" - "+data.pessoa_destino.pessoa_juridica.inscricao_estadual, value: data.pessoa_destino.pessoa_id}
          }
          else if(data.pessoa_destino.pessoa_exterior!==null)
          {
              this.form.pessoa_destino = {label: "PE -"+data.pessoa_destino.pessoa_exterior.nome+" - "+data.pessoa_destino.pessoa_exterior.cd, value: data.pessoa_destino.pessoa_id}
          }
      }
      this.form.param_carga = {label: data.param_tipo_carga.descr, value: data.param_tipo_carga.partipcar_id};
      this.valores.peso_cubado = parseInt(data.cotacao_carga.peso_cubado, 10);
      this.valores.peso_declarado = parseInt(data.cotacao_carga.peso_declarado, 10);
      this.valores.qtde_volume = parseInt(data.cotacao_carga.qtde_volume, 10);
      this.valores.peso_utilizado = parseInt(data.cotacao_carga.peso_utilizado, 10);
      this.valores.vlr_total_nfe = parseInt(data.cotacao_valor.vlr_total_nfe, 10);
      this.valores.aliquota = parseInt(data.cotacao_valor.aliquota, 10);
      this.valores.perc_desconto = parseInt(data.cotacao_valor.perc_desconto, 10);
      this.valores.vlr_frete = parseInt(data.cotacao_valor.vlr_frete, 10);
      this.valores.vlr_outros = parseInt(data.cotacao_valor.vlr_outros, 10);
      this.valores.vlr_imposto = parseInt(data.cotacao_valor.vlr_imposto, 10);
      this.valores.vlr_desconto = parseInt(data.cotacao_valor.vlr_desconto, 10);
      this.valores.vlr_total = parseInt(data.cotacao_valor.vlr_total, 10);
      this.valores.perc_reducao_bc = parseInt(data.cotacao_valor.perc_reducao_bc, 10);
      this.valores.vlr_bc_st_retido = parseInt(data.cotacao_valor.vlr_bc_st_retido, 10);
      this.valores.vlr_imposto_st_retido = parseInt(data.cotacao_valor.vlr_imposto_st_retido, 10);
      this.valores.vlr_credito_presumido = parseInt(data.cotacao_valor.vlr_credito_presumido, 10);
      this.valores.cotval_id = data.cotacao_valor.cotval_id,
      this.form.cst = data.cotacao_valor.cst;
      this.form.param_cst = {label: data.cotacao_valor.param_cst.descr, value: data.cotacao_valor.param_cst.parcst_id};
      data.cotacao_trecho.forEach((item, index) => {
        this.trecho.push({
          cep_origem: item.cep_origem,
          cep_destino: item.cep_destino,
          municipio_ori: {label: item.municipio_origem.nome, value: item.municipio_origem.municipio_id},
          municipio_des: {label: item.municipio_destino.nome, value: item.municipio_destino.municipio_id},
          uf_ori: item.municipio_origem.uf.cd,
          uf_des: item.municipio_destino.uf.cd,
          endereco_ori: item.endereco_ori,
          endereco_des: item.endereco_des,
          complemento_ori: item.complemento_ori,
          complemento_des: item.complemento_des,
          ordem: item.ordem,
          tp_servico: {label: item.tp_servico.descr, value: item.tp_servico.valor},
          carroceria: {label: item.param_tipo_carroceria.descr, value: item.param_tipo_carroceria.partipcro_id},
          modal: {label: item.b_modal.descr, value: item.b_modal.bmodal_id},
          tp_pedido: item.tp_pedido.valor,
          tp_trecho: item.tp_trecho.valor,
          tp_coleta_entrega: item.tp_coleta_entrega.valor,
          cottre_id: item.cottre_id,
          subtrecho: item.subtrecho,
          index: index,
          tabela_frete: [],
        })
        this.trecho[index].tabela_frete.push({
            tabela_frete: item.tabela_frete_vigencia.tabela_frete,
            valores: {valor_frete: data.cotacao_valor.vlr_frete}
        })
        console.log(this.trecho[index]);
        this.trecho[index].isVisibleTabela = true;
        });
      data.cotacao_contato.forEach((item, index) => {
          this.contato.push({
              nome: item.nome,
              email: item.email,
              telefone: item.telefone,
              cotcon_id: item.cotcon_id,
          })
      });
      data.cotacao_regra_fiscal.forEach((item, index) => {
          this.regra_fiscal.push({
              ordem: item.ordem,
              regra: {label: item.regra_fiscal.descr, value: item.regra_fiscal.regfis_id},
              cotregfis_id: item.cotregfis_id,
          })
      });
      data.cotacao_doc.forEach((item, index) => {
          if(item.chave_cte==null)//NFE
          {
            this.helpForm.chave = item.chave_nfe;
            this.addDoc(2);
          }
          else//CTE
          {
              this.helpForm.chave = item.chave_cte;
              this.addDocTransp(2);
          }
      });
      this.getMapa();
      this.form.cotacao_id = data.cotacao_id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.contato       = this.contato;
        this.form.trecho        = this.trecho;
        this.form.regra_fiscal  = this.regra_fiscal;
        this.form.docfis     = this.docfis;
        this.form.post('/api/cotacao/store').then(response =>
        {
            new ReturnApi(response, this)
        })
        .catch(errors => {
            new ReturnApi(errors, this)
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
                if (errors.hasOwnProperty(property)) {
                    if (typeof(errors[property]) === 'object') {
                        errors[property].forEach((obj) => {
                            this.errors_array.push({
                                erro: obj
                            });
                        });
                    }
                }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.post('/api/cotacao/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
        })
        .catch(errors => {
            new ReturnApi(errors, this)
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
                if (errors.hasOwnProperty(property)) {
                    if (typeof(errors[property]) === 'object') {
                        errors[property].forEach((obj) => {
                            this.errors_array.push({
                                erro: obj
                            });
                        });
                    }
                }
            }
        });
    },
    getLivGeral() {
        this.helpForm.get('/api/cotacao/jsonlistgeral').then(response => {
            new ReturnApi(response, this, true, false, false);
            response.cotacao_status.forEach((obj) => {
                this.optionsCotacaoStatus.push({label: obj.descr,value: obj.valor})
            })
            response.cotacao_origem.forEach((obj) => {
                this.optionsCotacaoOrigem.push({label: obj.descr,value: obj.valor})
            })
            response.cotacao_tp_carga.forEach((obj) => {
                this.optionsCotacaoTpCarga.push({text: obj.descr,value: obj.valor})
            })
            response.cotacao_tomador.forEach((obj) => {
                this.optionsCotacaoTomador.push({text: obj.descr,value: obj.valor})
            })
            response.trecho_tp_servico.forEach((obj) => {
                this.optionsTrechoTpServico.push({label: obj.descr,value: obj.valor})
            })
            response.trecho_tp_pedido.forEach((obj) => {
                this.optionsTrechoTpPedido.push({text: obj.descr,value: obj.valor})
            })
            response.trecho_tp_trecho.forEach((obj) => {
                this.optionsTrechoTpTrecho.push({text: obj.descr,value: obj.valor})
            })
            response.trecho_tp_coleta_entrega.forEach((obj) => {
                this.optionsTrechoTpColetaEntrega.push({text: obj.descr,value: obj.valor})
            })
            response.doc_tp_doc.forEach((obj) => {
                this.optionsDocTpDoc.push({label: obj.descr,value: obj.valor})
            })
            response.municipio.forEach((obj) => {
                this.optionsMunicipio.push({label: obj.nome, cd: obj.uf.cd, ibge:obj.cd_ibge, value: obj.municipio_id})
            })
            response.param_cst.forEach((obj) => {
                this.optionsParamCst.push({label: obj.cd+" - "+obj.descr, cd:obj.cd, value: obj.parcst_id})
            })
            response.param_tipo_carga.forEach((obj) => {
                this.optionsParamTipoCarga.push({label: obj.descr,value: obj.partipcar_id})
            })
            response.regra_fiscal.forEach((obj) => {
                this.optionsRegraFiscal.push({label: obj.descr,value: obj.regfis_id})
            })
            response.b_modal.forEach((obj) => {
                this.optionsModal.push({label: obj.descr, cd: obj.cd, value: obj.bmodal_id})
            })
            response.param_carroceria.forEach((obj) => {
                this.optionsParamCarroceria.push({label: obj.descr, value: obj.partipcro_id})
            })
        })
        .catch(errors => {
            new ReturnApi(errors, this)
        });
    },
    onBuscarDocAssociar(data){
        var c = true;
        data.forEach((obj)=>
        {
            c = true;
            this.docfis.forEach((obj2)=>{
                if(obj2.id==obj.id)
                {
                    c = false;
                }
            });

            if(c)
            {
                this.docfis.push({
                    id : obj.id,
                    chave : obj.chave,
                    num_fiscal : obj.num_fiscal,
                    serie : obj.serie,
                    dt_emissao : obj.dt_emissao,
                    emi_nome: obj.emi_nome,
                    emi_cnpj: obj.emi_cnpj,
                    des_nome: obj.des_nome,
                    des_cnpj: obj.des_cnpj,
                    tp_doc: obj.tp_doc,
                    vlr_total: obj.vlr_total_nfe
                });
                this.populaValores();
            }
        })
        this.$refs.modal_form.show();
    },
    listaClientesPessoa(search) {
        if(search.length>=3)
        {
            this.isLoadingPessoa = true;
            this.helpForm.search = search;
            this.helpForm.status = 1;
            this.helpForm.post('/api/pessoa/jsonlist').then(response =>
            {
                this.optionsPessoa = [];
                new ReturnApi(response, this, true, false, false);
                if(response.items.length>0)
                {
                    response.items.forEach((obj)=>
                    {
                        this.optionsPessoa.push({ label: "PJ -"+obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                }
                if(response.itemsF.length>0) {
                    response.itemsF.forEach((obj)=>
                    {
                        this.optionsPessoa.push({ label: "PF -"+obj.nome+" - "+obj.cpf, value: obj.pessoa_id })
                    });
                }
                if(response.itemsE.length>0)
                {
                    response.itemsE.forEach((obj)=>
                    {
                        this.optionsPessoa.push({ label: "PE -"+obj.nome+" - "+obj.cd, value: obj.pessoa_id })
                    });
                }
                this.isLoadingPessoa = false;
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
              });
          }
      },

    formatDate (value, fmt = 'DD/MM/YYYY') {
      return (value == null)
        ? ''
        : moment(value, 'YYYY-MM-DD').format(fmt)
    },
    limitText (count) {
      return ' e ${count} outros clientes'
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
        var cnpj_formatado
        var pad = "00000000";
        var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
        var pad = "0000"
        var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
        var pad = "00"
        var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
        return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    formatNumber(value) {
        return accounting.formatNumber(value, 2, '.', ',')
    },
    addRowContato: function(e) {
        e.preventDefault();
        this.contato.push({
            email: '',
            nome: '',
            telefone: '',
        });
    },
    removeRowContato: function(index) {
        this.contato.splice(index, 1);
    },
    addRowRegraFiscal: function(e) {
        e.preventDefault();
        this.regra_fiscal.push({
            ordem: '',
            regra: [],
        });
    },
    removeRowRegraFiscal: function(index) {
        this.regra_fiscal.splice(index, 1);
    },
    addRowTrecho: function(e) {
        this.index = this.trecho.length;
        this.trecho.push({
            cep_origem: '',
            municipio_ori: [],
            endereco_ori: '',
            complemento_ori: '',
            cep_destino: '',
            municipio_des: '',
            endereco_des: '',
            complemento_des: '',
            ordem: '',
            tp_servico: [],
            carroceria: [],
            tp_pedido: 1,
            uf: '',
            tp_trecho: 1,
            tp_coleta_entrega: 1,
            modal: [],
            tab_frete: [],
            obs: '',
            tabfrevig_id: '',
            isVisibleTabela: false,
            distancia: '',
            subtrecho: 2,
            index: this.index,
        });
    },
    removeRowTrecho: function(index) {
        this.trecho.splice(index, 1);
    },
    addRowSubTrecho: function(e) {
        e.preventDefault();
        this.index = this.trecho.length;
        this.trecho.push({
            cep_origem: '',
            municipio_ori: [],
            endereco_ori: '',
            complemento_ori: '',
            cep_destino: '',
            municipio_des: '',
            endereco_des: '',
            complemento_des: '',
            ordem: '',
            tp_servico: [],
            carroceria: [],
            tp_pedido: 1,
            uf: '',
            tp_trecho: 1,
            tp_coleta_entrega: 1,
            modal: [],
            tab_frete: [],
            obs: '',
            tabfrevig_id: '',
            isVisibleTabela: false,
            subtrecho: 1,
            distancia: '',
            index: this.index,
        });
    },
    removeRowSubTrecho: function(index) {
        this.trecho.splice(index, 1);
    },
    removeRowDoc: function(index) {
        this.docfis.splice(index, 1);
    },
    onDetail(data, field, event) {
        this.$refs.vuetable.toggleDetailRow(data.cotacao_id);
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        //return this.getPermissionFw(checkPermission);
        return true;
    },
    disableMultimodal(modal, index) {
        if(modal.cd==6 && index==0)
        {
            this.optionsModal.forEach((obj, i) => {
                if(obj.cd==6)
                {
                    this.optionsModal[i] = {label: obj.label, cd: obj.cd, value: obj.value, $isDisabled: true};
                    this.toggleMap();
                }

            })
        }
        else if (modal.cd!==6 && index==0) {
            this.optionsModal.forEach((obj, i) => {
                if(obj.cd==6)
                {
                    this.optionsModal[i] = {label: obj.label, cd: obj.cd, value: obj.value, $isDisabled: false};
                }

            })

        }
    },
    getIcms(trecho, index, vlr_tabela) {
        this.helpFormIcms.municipio_ori_id = 14884;//trecho[0].municipio_ori.value;
        this.helpFormIcms.municipio_des_id = 14884;//trecho[0].municipio_des.value; mudar para ultimo destino do ultimo trecho
        this.helpFormIcms.post('/api/cotacao/icms').then(response => {
                new ReturnApi(response, this, true, false, false);
                this.valores.aliquota = parseFloat(response.icms.aliquota_contribuinte);
                this.valores.vlr_frete = 0;
                this.trecho[index].valor_frete_individual = vlr_tabela;
                this.trecho.forEach((obj) => {
                    if(obj.modal.value==6)//Multimodal
                    {
                        obj.valor_frete_individual = 0;
                    }
                    this.valores.vlr_frete = parseFloat(obj.valor_frete_individual)+parseFloat(this.valores.vlr_frete);//Soma de todos os trechos
                })
                this.valores.vlr_imposto = parseFloat(response.icms.aliquota_contribuinte)*parseFloat(this.valores.vlr_frete/100);
                this.ajustaValores(this.valores);
            })
            .catch(errors => {
                new ReturnApi(errors, this)
            });
    },
    ajustaValores(valores_form) {console.log(valores_form);
        this.valores.vlr_frete = 0;
        this.trecho.forEach((obj) => {
            this.valores.vlr_frete = parseFloat(obj.valor_frete_individual)+parseFloat(this.valores.vlr_frete);//Soma de todos os trechos
        })
        this.vn_vlr_frete = parseFloat(valores_form.vlr_outros)+parseFloat(this.valores.vlr_frete);//Soma do vlr_outros com o valor do frete
        this.valores.vlr_desconto = parseFloat(valores_form.perc_desconto)*parseFloat(this.vn_vlr_frete/100);//Valor de desconto
        this.vn_vlr_frete_pos_desconto =  (parseFloat(this.vn_vlr_frete))-parseFloat(this.valores.vlr_desconto);//Subtrai o desconto do vlr do frete
        this.valores.vlr_imposto = parseFloat(valores_form.aliquota)*parseFloat(this.vn_vlr_frete_pos_desconto/100);//Valor imposto
        this.valores.vlr_total = parseFloat(this.vn_vlr_frete_pos_desconto)+parseFloat(this.valores.vlr_imposto);// Soma vlr_impost + vlr do frete
    },
    getCep(index, tipo) {
        if(tipo==1)//Origem
        {
            this.isLoadingEnderecoOri = true;
            this.helpForm.cep_busca = this.trecho[index].cep_origem;
        }
        if(tipo==2)//destino
        {
            this.isLoadingEnderecoDes = true;
            this.helpForm.cep_busca = this.trecho[index].cep_destino;
        }

        //Nova variável "cep" somente com dígitos.
        var cep = this.helpForm.cep_busca.replace(/\D/g, '');

        //Verifica se campo cep possui valor informado.
        if (cep != "") {
            //Expressão regular para validar o CEP.
            var validacep = /^[0-9]{8}$/;

            //Valida o formato do CEP.
            if (validacep.test(cep)) {
                this.loadingCep = true;
                this.helpForm.post('/api/cep/pesquisar').then(response => {
                        new ReturnApi(response, this, true, false, false);

                        this.helpForm.errors.clear();
                        if(tipo==1)//origem
                        {
                            response.forEach((obj) => {
                                this.trecho[index].endereco_ori = obj.logradouro;
                                this.trecho[index].complemento_ori = obj.complemento;
                                this.optionsMunicipio.forEach((obj2) => {
                                    this.trecho[index].uf_ori = obj.uf;
                                    if (obj2.ibge == obj.ibge) {
                                        this.trecho[index].municipio_ori = {
                                            label: obj2.label,
                                            value: obj2.value
                                        };
                                    }
                                });
                            });
                        }
                        else//destino
                        {
                            response.forEach((obj) => {
                                this.trecho[index].endereco_des = obj.logradouro;
                                this.trecho[index].complemento_des = obj.complemento;
                                this.optionsMunicipio.forEach((obj2) => {
                                    this.trecho[index].uf_des = obj.uf;
                                    if (obj2.ibge == obj.ibge) {
                                        this.trecho[index].municipio_des = {
                                            label: obj2.label,
                                            value: obj2.value
                                        };
                                    }
                                });
                            });
                        }
                        //Quando os endereços estiverem completos, monta o mapa
                        if(this.trecho[index].endereco_ori!=='' && this.trecho[index].endereco_des!=='')
                        {
                            this.getMapa(index);
                        }
                        this.loadingCep = false;
                        this.isLoadingEnderecoOri = false;
                        this.isLoadingEnderecoDes = false;
                    })
                    .catch(errors => {
                        this.loadingCep = false;
                        this.isLoadingEnderecoOri = false;
                        this.isLoadingEnderecoDes = false;
                        new ReturnApi(errors, this)
                    });
            } else {
                var errors = {
                    "errors": {
                        "emi_cep": ["Cep inválido"]
                    }
                };
                this.helpForm.errors.record(errors.errors);
                this.isLoadingEnderecoOri = false;
                this.isLoadingEnderecoDes = false;
            }
        }
    },
    getPesoUtilizado(data) {
        this.vn_peso_cubado = parseFloat(data.peso_cubado)*300;
        if(this.vn_peso_cubado > data.peso_declarado)
        {
            this.valores.peso_utilizado = this.vn_peso_cubado;
        }
        else if(this.vn_peso_cubado < data.peso_declarado)
        {
            this.valores.peso_utilizado = data.peso_declarado;
        }
        else
        {
            this.valores.peso_utilizado = data.peso_declarado;
        }
    },
    getCdCst(data) {
        this.form.cst = data.cd;
    },
    onDetalhesTabelaFrete(tabfrevig_id)     {
        this.$refs.detalhestabelafrete.onBuscaTabela(tabfrevig_id, this.form);
    },
    onGetTabelaFrete(i) {
        this.isLoadingTabelaFrete = true;
        this.form.tp_busca_tabela = 1;
        this.form.valores = this.valores;
        this.form.trecho = this.trecho;
        this.form.post('/api/cotacao/tabelafrete').then(response => {
                response.trecho.forEach((obj, index) => {
                    if(obj.tabela_frete.length>0)
                    {
                        this.trecho[index].tabela_frete = obj.tabela_frete;
                        this.trecho[index].isVisibleTabela = true;
                    }
                })
                this.isLoadingTabelaFrete = false;
                new ReturnApi(response, this, true, false, false);
            })
            .catch(errors => {
                new ReturnApi(errors, this)
                this.errors_array = '';
                this.errors_array = [];
                this.isLoadingTabelaFrete = false;
                for (var property in errors) {
                    if (errors.hasOwnProperty(property)) {
                        if (typeof(errors[property]) === 'object') {
                            errors[property].forEach((obj) => {
                                this.errors_array.push({
                                    erro: obj
                                });
                            });
                        }
                    }
                }
            });
    },
    getMapa() {
        this.vt_waypoint = null;
        this.v1_waypoint = '';
        this.v2_waypoint = '';
        this.trecho.forEach((obj, index) => {
            if(index == 0)
            {
                this.municipio_ori = obj.municipio_ori.label.replace(/ /g,"+");
                this.municipio_des = obj.municipio_des.label.replace(/ /g,"+");
                this.origem = obj.endereco_ori.replace(/ /g,"+")+'+'+this.municipio_ori;
                this.destino = obj.endereco_des.replace(/ /g,"+")+'+'+this.municipio_des;
            }
            else if(index == this.trecho.length-1)
            {
                this.municipio_des = obj.municipio_des.label.replace(/ /g,"+");
                this.municipio_ori = obj.municipio_ori.label.replace(/ /g,"+");
                this.destino = obj.endereco_des.replace(/ /g,"+")+'+'+this.municipio_des;
                this.waypoint = obj.endereco_ori.replace(/ /g,"+")+'+'+this.municipio_ori;
                this.v1_waypoint = this.waypoint;
            }
            else
            {
                this.municipio_ori = obj.municipio_ori.label.replace(/ /g,"+");
                this.waypoint = obj.endereco_ori.replace(/ /g,"+")+'+'+this.municipio_ori;
                if(this.v2_waypoint=='')
                {
                    this.v2_waypoint = this.waypoint;
                }
                else if(this.v2_waypoint!=='' && this.waypoint!=='')
                {
                    this.v2_waypoint = this.v2_waypoint+"|"+this.waypoint;
                }
            }
            if(this.v2_waypoint!=='' && this.v1_waypoint!=='')
            {
                this.vt_waypoint = this.v2_waypoint+"|"+this.v1_waypoint;
            }
            else if(this.v2_waypoint=='' && this.v1_waypoint!=='')
            {
                this.vt_waypoint = this.v1_waypoint;
            }
        })
        if(this.vt_waypoint!==null)
        {
            this.dados_mapa = 'https://www.google.com/maps/embed/v1/directions?key=AIzaSyCT3QaWzQaKokuqPLkaR9tz10qRG_FCp90&origin='+this.origem+'&destination='+this.destino+'&waypoints='+this.vt_waypoint+'';
            this.distancia_mapa = 'https://maps.googleapis.com/maps/api/directions/json?origin='+this.origem+'&destination='+this.destino+'&waypoints='+this.vt_waypoint+'&key=AIzaSyCT3QaWzQaKokuqPLkaR9tz10qRG_FCp90';
        }
        else
        {
            this.dados_mapa = 'https://www.google.com/maps/embed/v1/directions?key=AIzaSyCT3QaWzQaKokuqPLkaR9tz10qRG_FCp90&origin='+this.origem+'&destination='+this.destino+'';
            this.distancia_mapa = 'https://maps.googleapis.com/maps/api/directions/json?origin='+this.origem+'&destination='+this.destino+'&key=AIzaSyCT3QaWzQaKokuqPLkaR9tz10qRG_FCp90';
        }
        this.helpForm.distancia_mapa = this.distancia_mapa;
        this.helpForm.post('/api/cotacao/distanciamapa').then(response => {
                new ReturnApi(response, this, true, false, false);console.log(response);
                this.trecho.forEach((obj, index) => {console.log(obj.endereco_ori);
                    obj.distancia = response.va_distancias[index].distancia;
                    console.log(obj.distancia);
                })
            })
            .catch(errors => {
                new ReturnApi(errors, this)
            });
        console.log(this.trecho);
        this.isLoadingMapa = true;
        this.isLoadingMapa = false;
    },
    getEndereco(data, tipo) {
        if(tipo==1)
        {
            this.isLoadingEnderecoOri = true;
            this.helpForm.pessoa_id = data.pessoa_origem.value;
        }
        if(tipo==2)
        {
            this.isLoadingEnderecoDes = true;
            this.helpForm.pessoa_id = data.pessoa_destino.value;
        }
        this.helpForm.post('/api/cotacao/endereco').then(response => {
                new ReturnApi(response, this, true, false, false);
                if(tipo==1)//Origem
                {
                    this.trecho[0].cep_origem = response.endereco.cep;
                    this.trecho[0].endereco_ori = response.endereco.endereco;
                    this.trecho[0].complemento_ori = response.endereco.complemento;
                    this.trecho[0].uf_ori = response.endereco.municipio.uf.cd;
                    this.trecho[0].municipio_ori = {label: response.endereco.municipio.nome,value: response.endereco.municipio.municipio_id};
                }
                if(tipo==2)//Destino
                {
                    this.trecho[0].cep_destino = response.endereco.cep;
                    this.trecho[0].endereco_des = response.endereco.endereco;
                    this.trecho[0].complemento_des = response.endereco.complemento;
                    this.trecho[0].uf_des = response.endereco.municipio.uf.cd;
                    this.trecho[0].municipio_des = {label: response.endereco.municipio.nome,value: response.endereco.municipio.municipio_id};
                }
                //Quando os endereços estiverem completos, monta o mapa
                if(this.trecho[0].endereco_ori!=='' && this.trecho[0].endereco_des!=='')
                {
                    this.getMapa(0);
                }
                this.isLoadingEnderecoOri = false;
                this.isLoadingEnderecoDes = false;
            })
            .catch(errors => {
                this.isLoadingEnderecoOri = false;
                this.isLoadingEnderecoDes = false;
                new ReturnApi(errors, this)
            });
    },
    toggleMap() {
        this.showMap = !this.showMap;
    },
    onAprova(data) {
        this.form_cotacao.reset();
        let form = this.form_cotacao;
        var vm = this;
        if (data !== null) {
            var cotacao = data.cotacao_id;
        }

        const onConfirmUnitWrapper = () => {
            confirmPresenca(vm, cotacao);
        }

        let confirmPresenca = function(vm, cotacao) {
            vm.form_cotacao.cotacao_id = cotacao;
            vm.form_cotacao.dt_aprovacao = vm.formatDateSubmit(vm.form_cotacao.dt_aprovacao);
            vm.form_cotacao.post('/api/cotacao/store/aprovacao').then(response => {
                    new ReturnApi(response, vm)
                })
                .catch(errors => {
                    new ReturnApi(errors, vm)
                });
        }
        let obj = {
            title: 'Aprovar?',
            message: 'Você deseja aprovar essa cotação ?',
            customConfirmBtnText: 'Sim',
            customCloseBtnText: 'Não',
            type: 'info',
            useConfirmBtn: true,
            onConfirm: onConfirmUnitWrapper
        }

        this.$Simplert.open(obj);

    },
    onGeraPedido(data) {
        this.form_cotacao.reset();
        let form = this.form_cotacao;
        var vm = this;
        if (data !== null) {
            var cotacao = data.cotacao_id;
        }

        const onConfirmUnitWrapper = () => {
            confirmPresenca(vm, cotacao);
        }

        let confirmPresenca = function(vm, cotacao) {
            vm.form_cotacao.cotacao_id = cotacao;
            vm.form_cotacao.post('/api/cotacao/store/pedido').then(response => {
                    new ReturnApi(response, vm)
                })
                .catch(errors => {
                    new ReturnApi(errors, vm)
                });
        }
        let obj = {
            title: 'Gerar pedido?',
            message: 'Você deseja gerar um pedido através dessa cotação ?',
            customConfirmBtnText: 'Sim',
            customCloseBtnText: 'Não',
            type: 'info',
            useConfirmBtn: true,
            onConfirm: onConfirmUnitWrapper
        }

        this.$Simplert.open(obj);

    },
    onCancela(data) {
        this.form_cancela.reset();
        let form = this.form_cancela;
        var vm = this;
        if (data !== null) {
            var cotacao = data.cotacao_id;
        }

        const onConfirmUnitWrapper = () => {
            confirmPresenca(vm, cotacao);
        }

        let confirmPresenca = function(vm, cotacao) {
            vm.form_cancela.cotacao_id = cotacao;
            vm.form_cancela.dt_cancelamento = vm.formatDateSubmit(vm.form_cancela.dt_cancelamento);
            vm.form_cancela.post('/api/cotacao/store/cancelamento').then(response => {
                    new ReturnApi(response, vm)
                })
                .catch(errors => {
                    new ReturnApi(errors, vm)
                });
        }
        let obj = {
            title: 'Cancelar ?',
            message: 'Você deseja cancelar essa cotação ?',
            customConfirmBtnText: 'Sim',
            customCloseBtnText: 'Não',
            type: 'info',
            useConfirmBtn: true,
            onConfirm: onConfirmUnitWrapper
        }

        this.$Simplert.open(obj);

    },
    formatDateSubmit(value, fmt = 'DD/MM/YYYY') {
        return (value == null || value == '') ?
            '' :
            moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
    },
    getUfMunicipio(index, data, tipo) {
        //tipo 1 = Origem; 2 = Destino
        if(tipo==1)
        {
            this.trecho[index].uf_ori = data.municipio_ori.cd;
        }
        if(tipo==2)
        {
            this.trecho[index].uf_des = data.municipio_des.cd;
        }
    },
    classSubtrecho : function(item){
        if(item.subtrecho==1)
        {
            return 'table-success pt-1';
        }
        else
        {
            return 'pt-1';
        }
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
        get() {
            return this.$store.getters.currency;
        }
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
